<mat-horizontal-stepper #pasos>
  <mat-step>
    <ng-template matStepLabel>overview</ng-template>
    <vista-gen (cambiaPaso)="cambiaPaso($event)" [actualizaGetTemplateFaltantes]="actualizaGetTemplateFaltantes.asObservable()"></vista-gen>
  </mat-step>
  <ng-container *ngIf="instituto">
    <!-- <ng-container *ngIf="instituto == 3 || instituto == 5"> -->
      <mat-step>
        <ng-template matStepLabel>vista correos</ng-template>
        <correos (cambiaPaso)="cambiaPaso($event)" (enviaDatosEditor)="enviaInfoEditor($event)" [actualizaEmail]="actualizaEmail.asObservable()"></correos>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>edicion correos</ng-template>
        <editorEmail (cambiaPaso)="cambiaPaso($event)" (getTemplateFaltantes)="getTemplateFaltantes($event)"  [entradaDatos]="enviaDatosEditor.asObservable()"></editorEmail>
      </mat-step>
    <!-- </ng-container> -->
  </ng-container>
</mat-horizontal-stepper>
